import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { BankStatements2MonthRuleset } from '../../business/ruleset';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';

const {
  formField: {
    documents: { bankStatement2Month },
  },
} = loanFormModel;

export class BankStatements2MonthValidation implements ValidationSchema {
  public name: string = bankStatement2Month.name;
  public label: string = bankStatement2Month.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = BankStatements2MonthRuleset;

  public when(schema: any, context: any, rulesetResult: RulesetResult) {
    const required = !!(rulesetResult & RulesetResult.REQUIRED);
    const fileSchema = FileNameValidationSchema(
      bankStatement2Month.name,
      required
    );
    if (required) {
      return fileSchema.required('This document is required');
    }
    return fileSchema;
  }
}

export default new Validation(new BankStatements2MonthValidation());
